import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function cleanHost(raw: string) {
  return (
    raw
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .split("/")[0]
      .split("?")[0] || "example.com"
  );
}

export function validateDomain(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return "Enter a domain to test";
  if (/\s/.test(trimmed)) return "Domain can't contain spaces";
  let domain = trimmed
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "");
  domain = domain.split(/[/?#]/)[0];
  const re = /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;
  if (!re.test(domain)) return "Enter a valid domain like example.com";
  return null;
}

export function countryToFlag(code: string): string {
  if (!code || code.length !== 2) return "🌐";
  return Array.from(code.toUpperCase())
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");
}

/** Latency color ramp — green (fast) → yellow → orange (slow). */
export function msColor(ms: number) {
  if (ms < 1500) return "#4ade80"; // green
  if (ms < 3000) return "#facc15"; // yellow
  return "#fb923c"; // orange
}
